import React from 'react';
import * as S from './Shimmer.styles';



const Shimmer: React.FC = (props) => (
  <S.Placeholder {...props} />
);

export default Shimmer;